import * as yup from "yup";

export interface SigninAuthValues {
    email: string;
    password: string;
}

export const emptySigninFormValue: SigninAuthValues = {
    email: "",
    password: "",
};

export const signinSchema: yup.Schema<SigninAuthValues> = yup.object({
    email: yup.string().email("Invalid email").required("Email is required"),
    password: yup.string().trim().required("Password is required"),
});

export interface SignupAuthValues {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
}

export const emptySignupFormValue: SignupAuthValues = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
};

export const signUpSchema: yup.Schema<SignupAuthValues> = yup.object({
    firstName: yup.string().required("First name is required"),
    lastName: yup.string().required("Last name is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    password: yup
        .string()
        .trim()
        .required("Password is required")
        .min(8, "Password must be at least 8 characters")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(
            /[!@#$%^&*(),.?":{}|<>/]/,
            "Password must contain at least one symbol"
        ),
});

export interface WorkSpaceNameValues {
    businessName: string;
}

export const emptyWorkSpaceNameValue: WorkSpaceNameValues = {
    businessName: "",
};
export const workSpaceNameSchema: yup.Schema<WorkSpaceNameValues> = yup.object({
    businessName: yup.string().required("Business name is required"),
});

export interface ForgotPasswordValues {
    email: string;
}

export const emptyForgotPasswordValue: ForgotPasswordValues = {
    email: "",
};

export const forgotPasswordSchema: yup.Schema<ForgotPasswordValues> =
    yup.object({
        email: yup
            .string()
            .email("Invalid email")
            .required("Email is required"),
    });

export interface ResetPasswordValues {
    password: string;
    confirmPassword: string;
}

export const emptyResetPasswordValue: ResetPasswordValues = {
    password: "",
    confirmPassword: "",
};

export const resetPasswordSchema: yup.Schema<ResetPasswordValues> = yup.object({
    password: yup
        .string()
        .trim()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(
            /[!@#$%^&*(),.?":{}|<>/]/,
            "Password must contain at least one symbol"
        ),
    confirmPassword: yup
        .string()
        .oneOf([yup.ref("password")], "Passwords must match")
        .required("Confirm Password is required"),
});
